export interface Day {
    date: Date;
    from: Date;
    to: Date;
    lunch: boolean;
    note: string;
}